import { render, staticRenderFns } from "./imgexhibite.vue?vue&type=template&id=7850bbd1&scoped=true&"
import script from "./imgexhibite.vue?vue&type=script&lang=js&"
export * from "./imgexhibite.vue?vue&type=script&lang=js&"
import style0 from "./imgexhibite.vue?vue&type=style&index=0&id=7850bbd1&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7850bbd1",
  null
  
)

export default component.exports